<template>
	<v-card>
		<v-card-title>
			<span class="text-h5">{{ formTitle }}</span>
		</v-card-title>

		<v-card-text>
			<v-container>
				<v-row>
					<!-- タイトル -->
					<v-col cols="12">
						<label class="field-label">タイトル *</label>
						<VmTextField v-model="editedItem.title" :value="editedItem.title" @input="editedItem.title = $event" />
						<div v-if="!editedItem.title" class="error-text">タイトルは必須です</div>
						<div v-if="editedItem.title && editedItem.title.length > 100" class="error-text">
							タイトルは100文字以下で入力してください
						</div>
					</v-col>

					<!-- 内容 -->
					<v-col cols="12">
						<label class="field-label">内容 *</label>
						<VmTextArea
							v-model="editedItem.content"
							:value="editedItem.content"
							@input="editedItem.content = $event"
							placeholder="お知らせの内容を入力してください"
						/>
						<div v-if="!editedItem.content" class="error-text">内容は必須です</div>
						<div v-if="editedItem.content && editedItem.content.length > 1000" class="error-text">
							内容は1000文字以下で入力してください
						</div>
					</v-col>

					<!-- 対象生徒選択 -->
					<v-col cols="12">
						<label class="field-label">対象生徒 *</label>
						<v-autocomplete
							:items="studentSelectOptions"
							v-model="editedItem.targetStudent"
							label="対象生徒を選択してください"
							outlined
							background-color="white"
							no-data-text="生徒がいません"
							item-text="label"
							item-value="value"
							:loading="studentsLoading"
							clearable
						></v-autocomplete>
						<div v-if="studentsLoading" class="loading-text">生徒一覧を読み込み中...</div>
						<div v-if="!editedItem.targetStudent" class="error-text">対象生徒を選択してください</div>
					</v-col>
				</v-row>
			</v-container>
		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>
			<div class="button-group">
				<VmButton text="キャンセル" type="cancel" :disabled="loading" @click="closeAction" />
				<VmButton
					:text="buttonTitle === 'edit' ? '更新' : '作成'"
					type="primary"
					:disabled="!isFormValid || loading"
					@click="addAction"
				/>
			</div>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VmTextField from '../Atoms/VmTextField'
import VmTextArea from '../Atoms/VmTextArea'
import VmButton from '../Atoms/VmButton'

export default {
	name: 'AdminAnnouncementFormCard',
	components: {
		VmTextField,
		VmTextArea,
		VmButton
	},
	props: {
		editedItem: {
			type: Object,
			required: true
		},
		formTitle: {
			type: String,
			default: 'お知らせ'
		},
		buttonTitle: {
			type: String,
			default: 'add'
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters({
			userInfo: 'user/getUserInfo',
			students: 'adminStudent/students',
			studentsLoading: 'adminStudent/loading'
		}),
		isFormValid() {
			return (
				this.editedItem.title &&
				this.editedItem.content &&
				this.editedItem.targetStudent &&
				this.editedItem.title.length <= 100 &&
				this.editedItem.content.length <= 1000
			)
		},
		selectedStudentName() {
			if (this.editedItem.targetStudent && this.students) {
				const student = this.students.find((s) => s.id === this.editedItem.targetStudent)
				return student ? student.name : ''
			}
			return ''
		},
		studentSelectOptions() {
			if (!this.students) return []
			return this.students.map((student) => ({
				label: `${student.name} (${student.email})`,
				value: student.id
			}))
		}
	},
	async created() {
		await this.fetchStudents()
	},
	methods: {
		...mapActions({
			fetchStudentsAction: 'adminStudent/fetchStudents'
		}),
		closeAction() {
			this.$emit('closeAction')
		},
		addAction() {
			this.$emit('addAction')
		},
		async fetchStudents() {
			try {
				// AdminStudentListと同じ方法でVuexストアから生徒一覧を取得
				await this.fetchStudentsAction({
					accessToken: this.userInfo.accessToken,
					page: 1,
					searchQuery: '' // 全件取得のため空文字
				})
			} catch (error) {
				console.error('生徒一覧の取得に失敗しました:', error)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.field-label {
	display: block;
	font-size: 14px;
	font-weight: 600;
	color: #333;
	margin-bottom: 8px;
}

.error-text {
	color: #e74c3c;
	font-size: 12px;
	margin-top: 4px;
}

.loading-text {
	color: #666;
	font-size: 12px;
	margin-top: 4px;
}

.v-card-title {
	word-break: break-word;
}

.button-group {
	display: flex;
	gap: 12px;
}
</style>
